<template>
  <section>
    <scroll-container
      class="pt-2 mt-n40px"
      height-offset="140px"
    >
      <b-skeleton
        v-if="isLoading"
        class="my-50"
        animation="wave"
        height="380px"
      />
      <b-card
        v-else
        class="my-50"
        no-body
      >
        <div class="p-2">
          <div class="row pb-50">
            <div class="col-md-4">
              <b-form-group
                :label="$tk('ClientPortal.Form.Name')"
                label-size="xs"
                :invalid-feedback="errors['Name']"
              >
                <b-form-input
                  v-model="sectionInfoModel.name"
                  size="sm"
                  type="text"
                  :placeholder="$tk('ClientPortal.Form.NamePlaceholder')"
                  :state="errors['Name'] == null ? null : false"
                />
              </b-form-group>
            </div>
            <div class="col-md-8">
              <b-form-group
                :label="$tk('ClientPortal.Admin.Info.Active')"
                label-size="xs"
              >
                <b-form-checkbox
                  v-model="sectionInfoModel.active"
                  class="d-block"
                  checked="false"
                  name="check-button"
                  switch
                />
              </b-form-group>
            </div>
          </div>
          <b-form-group
            :label="$tk('ClientPortal.Admin.Info.ContentEditor')"
            label-size="xs"
            class="col-md-12 p-0"
          >
            <quill-editor
              ref="quillEditor"
              v-model="sectionInfoModel.htmlContent"
              :options="editorOption"
            />
          </b-form-group>
        </div>
      </b-card>
    </scroll-container>
    <div class="border-top text-right py-1">
      <b-button
        class="bg-white"
        variant="outline-dark"
        size="sm"
        :to="`/admin/info/sectiongroup/${sectionInfoModel.groupId}`"
      >
        {{ $tk('ClientPortal.Form.Actions.Cancel') }}
      </b-button>
      <b-button
        class="ml-50"
        size="sm"
        variant="primary"
        :disabled="saving || isLoading"
        @click="save"
      >
        {{ $tk('ClientPortal.Admin.SaveChanges') }}
      </b-button>
    </div>
  </section>
</template>

<script>
import { VBModal } from 'bootstrap-vue'
import {
  onMounted,
  ref,
} from '@vue/composition-api'
import notification from '@/mixins/toastification'
import InfoService from '@/api/admin/info.service'
import translation from '@/mixins/translate'
import { quillEditor } from 'vue-quill-editor'
import ScrollContainer from '@/components/ScrollContainer.vue'

export default {
  directives: {
    'b-modal': VBModal,
  },
  components: {
    // Bootstrap Components
    quillEditor,
    ScrollContainer,
  },
  mixins: [notification],
  setup(_, context) {
    const isLoading = ref(false)
    const errors = ref({})
    const sectionInfoModel = ref({})
    const saving = ref(false)
    const { id } = context.root.$route.params
    const editorOption = ref({
      theme: 'snow',
      modules: {
        toolbar: [
          ['bold', 'italic', 'underline'],
          ['blockquote', 'code-block'],
          [{ header: 1 }, { header: 2 }, { header: 3 }],
          [{ list: 'ordered' }, { list: 'bullet' }],

          [{ indent: '-1' }, { indent: '+1' }],
          [{ direction: 'rtl' }],
          [{ size: ['small', false, 'large', 'huge'] }],
          [{ header: [1, 2, 3, 4, 5, 6, false] }],

          [{ color: [] }, { background: [] }],
          [{ align: [] }],
          ['clean'],
          ['link', 'image'],
        ],
      },
    })

    onMounted(async () => {
      isLoading.value = true
      sectionInfoModel.value = await InfoService.getSection(id)
      isLoading.value = false
    })

    const save = async () => {
      saving.value = true
      try {
        const response = await InfoService.updateSection(sectionInfoModel.value)
        if (response.saved) {
          errors.value = {}
          response.message
            ? notification.methods.success(response.message)
            : notification.methods.success(translation.methods.$tk('ClientPortal.Admin.ChangesHaveBeenSavedSuccesfully'))
        } else {
          notification.methods.error(response.message)
          errors.value = response.errors
        }
      } catch (err) {
        notification.methods.error(err.message)
      } finally {
        saving.value = false
      }
    }

    return {
      isLoading,
      errors,
      sectionInfoModel,
      saving,
      save,
      editorOption,
    }
  },
}
</script>
